/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MemberPreview,
    MemberPreviewFromJSON,
    MemberPreviewFromJSONTyped,
    MemberPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface ElementsGroupReference
 */
export interface ElementsGroupReference {
    /**
     * 
     * @type {number}
     * @memberof ElementsGroupReference
     */
    id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsGroupReference
     */
    readonly permissions?: Array<string>;
    /**
     * 
     * @type {Array<MemberPreview>}
     * @memberof ElementsGroupReference
     */
    readonly membersPreview?: Array<MemberPreview>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsGroupReference
     */
    readonly effectivePermissions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroupReference
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroupReference
     */
    readonly ldapDn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroupReference
     */
    readonly unixGroupname?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsGroupReference
     */
    readonly gid?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsGroupReference
     */
    readonly ldap?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ElementsGroupReference
     */
    readonly members?: Array<number>;
}

export function ElementsGroupReferenceFromJSON(json: any): ElementsGroupReference {
    return ElementsGroupReferenceFromJSONTyped(json, false);
}

export function ElementsGroupReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsGroupReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'membersPreview': !exists(json, 'members_preview') ? undefined : ((json['members_preview'] as Array<any>).map(MemberPreviewFromJSON)),
        'effectivePermissions': !exists(json, 'effective_permissions') ? undefined : json['effective_permissions'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'ldapDn': !exists(json, 'ldap_dn') ? undefined : json['ldap_dn'],
        'unixGroupname': !exists(json, 'unix_groupname') ? undefined : json['unix_groupname'],
        'gid': !exists(json, 'gid') ? undefined : json['gid'],
        'ldap': !exists(json, 'ldap') ? undefined : json['ldap'],
        'members': !exists(json, 'members') ? undefined : json['members'],
    };
}

export function ElementsGroupReferenceToJSON(value?: ElementsGroupReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


